import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

const FileOriginalName = ({ file }) => {
  const intl = useIntl();

  const [linkCopied, setLinkCopied] = useState(false);

  const copyLink = () => {
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 2000);
  };

  return (
    <span className="file-original-name">
      {intl.formatMessage({
        defaultMessage: 'Original file name: {fileName}',
      }, { fileName: file.original_name })}
      <CopyToClipboard
        text={file.original_name}
        title={intl.formatMessage({ defaultMessage: 'Copy original file name' })}
        options={{
          format: 'text/plain',
        }}
        onCopy={copyLink}
      >
        {linkCopied ? (
          <span>{intl.formatMessage({ defaultMessage: 'Copied' })}</span>
        ) : (
          <a href="#copy" onClick={(e) => { e.preventDefault(); }}>
            <i className="far fa-copy" />
          </a>
        )}
      </CopyToClipboard>
    </span>
  );
};

FileOriginalName.propTypes = {
  file: PropTypes.object.isRequired,
};

export default FileOriginalName;
